<template>
  <path
    d="M9 23.0002H15C15.55 23.0002 16 22.5502 16 22.0002C16 21.4502 15.55 21.0002 15 21.0002H9C8.45 21.0002 8 21.4502 8 22.0002C8 22.5502 8.45 23.0002 9 23.0002ZM16 1.01018L8 1.00018C6.9 1.00018 6 1.90018 6 3.00018V17.0002C6 18.1002 6.9 19.0002 8 19.0002H16C17.1 19.0002 18 18.1002 18 17.0002V3.00018C18 1.90018 17.1 1.01018 16 1.01018ZM16 15.0002H8V5.00018H16V15.0002Z"
  />
</template>
